import React, { useEffect } from 'react';

import { Wrapper, ImageWrapper, Image } from './styled-components';

const Gallery = ({ isSlider, images }) => {
  useEffect(() => {
    if (isSlider && window) {
      const { $ } = window;

      $(document).ready(() => {
        $('.eg_gallery').slick({
          arrows: true,
          adaptiveHeight: false,
          dots: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: false,
                dots: true,
              },
            },
          ],
        });
      });
    }
  }, []);

  return (
    <Wrapper isSlider={isSlider} className={isSlider && 'eg_gallery'}>
      {images.map((image, index) => (
        <ImageWrapper key={index} isSlide={isSlider} imageCount={images.length}>
          <Image src={image.file.url} alt={image.description} title={image.title}></Image>
        </ImageWrapper>
      ))}
    </Wrapper>
  );
};

Gallery.defaultProps = {
  isSlider: false,
  images: [
    { title: 'title', description: 'description', file: { url: 'https://picsum.photos/1920/1200' } },
    { title: 'title', description: 'description', file: { url: 'https://picsum.photos/800/1800' } },
    { title: 'title', description: 'description', file: { url: 'https://picsum.photos/1920/1200' } },
    { title: 'title', description: 'description', file: { url: 'https://picsum.photos/1920/1200' } },
  ],
};

export default Gallery;
